var _defs, _path, _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeadershipDevelopment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_69",
    "data-name": "Group 69",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 85,
    height: 85,
    transform: "translate(0 0)",
    fill: "#dd4633"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M292.655,309.072,292.5,325.6h20.254V309Z",
    transform: "translate(-227.754 -240.602)",
    fill: "#dd4633"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 20.254,
    height: 11.787,
    transform: "translate(43.164 73.213)",
    fill: "#dd4633"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 20.254,
    height: 7.637,
    transform: "translate(21.582 77.363)",
    fill: "#dd4633"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 20.254,
    height: 3.819,
    transform: "translate(0 81.181)",
    fill: "#dd4633"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M344.956,0c-.12.746-1.006,1.473-1.006,2.241,0,.727.925,1.65,1.006,2.407h-8.965v9.463h-1.5V0Z",
    transform: "translate(-260.454 0)",
    fill: "#dd4633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M206.27,103.571V112.7h-5.312v-6.558L190.005,99.82c-.344-.191-1,.437-1,.68V117.35h-5.4l-.249-.249V86.222c0-.345-.772-.276-1.089-.091-.733.428-2.239,2.589-2.976,3.331a5.1,5.1,0,0,1-2.157,1.5c-2.156.846-4.652,1.25-6.812,2.153.018-1.817-.2-3.052-1.575-4.313,1.625-.534,3.47-1.013,5.024-1.7,3.988-1.765,5.277-7.015,9.577-8.353,5.992-.535,12.606.454,18.525-.069,1.3-.115,1.92-.582,2.069-1.915.249-2.224-.435-5.924.078-7.891a2.269,2.269,0,0,1,4.411.746,80.892,80.892,0,0,1,0,10.97,2.308,2.308,0,0,1-2.125,2.357c-2.31.337-5.4-.282-7.573.728a5.463,5.463,0,0,0-2.933,4.04c-.279,3.111.154,6.728.089,9.885Z",
    transform: "translate(-131.397 -52.438)",
    fill: "#dd4633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M14.944,191.918a4.369,4.369,0,0,1-3.472-3.418c.332-4.357-.495-9.5-.015-13.765.254-2.261,2.714-3.371,4.733-3.568,6.184-.6,13.377.6,19.568-.021,2.513-.251,6.669-2.722,8.823-2.474a2.169,2.169,0,0,1,.87,3.866,60.806,60.806,0,0,1-7.921,2.87c-3.236.512-6.907-.937-8.673,3.114-.677,1.552-.633,6.822-.473,8.672a2,2,0,0,0,.159.8l10.14,5.755v7.139H33.537v-4.565a5.9,5.9,0,0,0-1.549-1.108c-2.906-1.777-6.034-3.236-8.958-4.989-.284-.311-1.115.014-1.115.286V205.2H16.438V176.893c0-.768-1.494-.768-1.494,0Z",
    transform: "translate(-8.801 -131.322)",
    fill: "#dd4633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M252.495,56.152c8.224-1.2,6.6,11.017,1.093,11.183-5.021.152-7.037-10.315-1.093-11.183",
    transform: "translate(-193.765 -43.658)",
    fill: "#dd4633"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M45.248,120.29c7.162-.008,5.165,11.7-.677,10.878-4.341-.61-6.18-10.869.677-10.878",
    transform: "translate(-31.69 -93.663)",
    fill: "#dd4633"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadershipDevelopment);
export default __webpack_public_path__ + "static/media/leadership_development.7612133caeb36f214a0685c815294237.svg";
export { ForwardRef as ReactComponent };